App.controller('LifeWithPaymentsChangeCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'lifeInsuranceWithPaymentsService', 'popUpService', function ($scope, $stateParams, $state, $timeout, lifeInsuranceWithPaymentsService, popUpService) {
    $scope.page = 'insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Formularz zmiany danych';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.list';
    $scope.$emit('link', $scope.link);

    let declaration = null;
    let originalPersonalDetails = null;

    if (!$stateParams.declaration) {
        $state.go('root.life.list', angular.extend($stateParams), {inherit: false});
    } else {
        declaration = $stateParams.declaration;
        let person = declaration.person;
        $scope.personalDetails = {
            address: angular.copy(person.address),
            lastName: person.lastName,
            email: person.email,
            phone: person.phone,
            optionalAgreementAccepted1: declaration.optionalAgreementAccepted1,
            optionalAgreementAccepted2: declaration.optionalAgreementAccepted2
        }
        originalPersonalDetails = angular.copy($scope.personalDetails)
    }
    $scope.requiredAgreementAccepted1 = false;
    $scope.requiredAgreementAccepted2 = false;
    $scope.requiredAgreementAccepted3 = false;

    $scope.save = function () {
        let vm = this;

        if (!vm.form.$valid) {
            if (!$scope.isAllRequiredChecked()) {
                popUpService.showPopUp({content: 'Aby zapisać wniosek, oznacz wszystkie oświadczenia obowiązkowe (oznaczone gwiazdką).'});
                return 0;
            }
            popUpService.showPopUp({content: 'Aby zapisać formularz, wypełnij wszystkie wymagane pola (oznaczone gwiazdką).'});
            return 0;
        }

        if (angular.equals(originalPersonalDetails, $scope.personalDetails)) {
            popUpService.showPopUp({content: 'Aby zapisać formularz, musisz wprowadzić zmiany.'});
            return 0;
        }

        let zipCode = $scope.personalDetails.address.zipCode;
        if (!zipCode.contains('-') && $scope.personalDetails.address.country !== 'OTHER') {
            zipCode = zipCode.substring(0, 2) + '-' + zipCode.substring(2);
            $scope.personalDetails.address.zipCode = zipCode;
        }

        lifeInsuranceWithPaymentsService.changePersonalDetails(declaration.uuid, $scope.personalDetails).then(
            function (success) {
                if (success.status === 200) {
                    popUpService.showPopUp({
                        content: 'Zmiany zostały poprawnie zapisane i zostaną przekazane do UNUM',
                        text: 'Podgląd wniosku',
                        target: 'root.life.details({declarationUuid: "' + declaration.uuid + '"})'
                    });
                } else {
                    popUpService.showPopUpWithError(error.data, {
                        head: 'Wystąpił błąd',
                        content: 'Nie udało się zapisać formularza zmian, prosimy spróbować ponownie później.'
                    });
                }
            },
            function (error) {
                popUpService.showPopUpWithError(error.data, {
                    head: 'Wystąpił błąd',
                    content: 'Nie udało się zapisać formularza zmian, prosimy spróbować ponownie później.'
                });
            }
        );
    }

    $scope.isAllRequiredChecked = function() {
        return $scope.requiredAgreementAccepted1 && $scope.requiredAgreementAccepted2 && $scope.requiredAgreementAccepted3;
    }

    $scope.toggleAllRequired = function() {
        let current = $scope.isAllRequiredChecked();
        $scope.requiredAgreementAccepted1 = !current;
        $scope.requiredAgreementAccepted2 = !current;
        $scope.requiredAgreementAccepted3 = !current;
    }
}]);